import { render, staticRenderFns } from "./ad-table.vue?vue&type=template&id=42118bdc&scoped=true"
import script from "./ad-table.vue?vue&type=script&lang=js"
export * from "./ad-table.vue?vue&type=script&lang=js"
import style0 from "./ad-table.vue?vue&type=style&index=0&id=42118bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42118bdc",
  null
  
)

export default component.exports